var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11184_14893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91997 14.7001C2.89997 15.7201 0.846639 15.2734 0.846639 15.2734C0.846639 15.2734 0.399971 13.2201 1.41997 12.2001C2.43997 11.1801 3.36664 11.9601 3.76664 12.3534C4.16664 12.7468 4.94664 13.6734 3.91997 14.7001Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1934 3.08622L14.06 2.21289",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88659 11.5536L6.99992 13.4603C7.01432 13.5214 7.04385 13.5778 7.08579 13.6244C7.12772 13.671 7.18072 13.7062 7.23992 13.727C7.29525 13.747 7.35499 13.7513 7.41265 13.7396C7.47025 13.7278 7.52352 13.7004 7.56659 13.6603L9.77992 11.8136C9.94725 11.6402 10.0613 11.4224 10.1085 11.186C10.1558 10.9497 10.1343 10.7048 10.0466 10.4803L9.75992 9.76029L12.0399 8.38029C12.425 8.14255 12.7449 7.81269 12.9707 7.42049C13.1965 7.02829 13.3211 6.58603 13.3333 6.13363L13.2199 3.08697L10.1733 2.97363C9.72319 2.98291 9.28225 3.10267 8.88932 3.32239C8.49639 3.54211 8.16352 3.85503 7.91992 4.23363L6.38659 6.77362L5.65325 6.51363C5.42926 6.42589 5.18491 6.40373 4.94879 6.44978C4.71266 6.49582 4.49453 6.60815 4.31992 6.77362L2.64659 8.70695C2.60384 8.74975 2.57471 8.80422 2.56284 8.86355C2.55098 8.92289 2.55692 8.98435 2.57992 9.04029C2.6015 9.09782 2.63626 9.14949 2.68141 9.19122C2.72656 9.23289 2.78085 9.26335 2.83992 9.28029L4.91325 9.58029L6.88659 11.5536Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1733 6.35645C10.0353 6.35645 9.92334 6.24452 9.92334 6.10645C9.92334 5.96838 10.0353 5.85645 10.1733 5.85645",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1733 6.35645C10.3114 6.35645 10.4233 6.24452 10.4233 6.10645C10.4233 5.96838 10.3114 5.85645 10.1733 5.85645",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0868 11.2939H13.9201C13.7551 11.3105 13.6022 11.388 13.4912 11.5113C13.3803 11.6345 13.3193 11.7947 13.3201 11.9606C13.3147 12.0901 13.3472 12.2182 13.4134 12.3295C13.4798 12.4408 13.577 12.5304 13.6934 12.5873L14.8734 12.9939C14.9911 13.0499 15.0898 13.139 15.1573 13.2504C15.2248 13.3617 15.2582 13.4905 15.2534 13.6206C15.2543 13.7865 15.1932 13.9467 15.0823 14.0699C14.9714 14.1932 14.8184 14.2707 14.6534 14.2873H13.2534",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2534 11.2936V10.627",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2534 14.9606V14.2939",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07967 1.29199H1.913C1.74448 1.31369 1.5906 1.39891 1.4828 1.53025C1.375 1.66159 1.32142 1.82914 1.333 1.99866C1.32762 2.12809 1.36006 2.25629 1.42636 2.36759C1.49266 2.47887 1.58995 2.56844 1.70634 2.62533L2.88634 3.03199C3.00272 3.08888 3.10001 3.17845 3.16631 3.28974C3.23261 3.40103 3.26505 3.52923 3.25967 3.65866C3.26066 3.82347 3.20058 3.98281 3.09101 4.10593C2.98144 4.22904 2.83014 4.3072 2.66634 4.32533H1.24634",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24634 1.29264V0.625977",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24634 4.95866V4.29199",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11184_14893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.4164ffcd.svg";
export { ForwardRef as ReactComponent };